const ChevronIcon = () => (
  <svg width="13" height="10" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.2153 11.9455C15.5183 12.338 16.0448 12.3778 16.3912 12.0344C16.7375 11.6909 16.7727 11.0942 16.4696 10.7017L8.96544 0.711341C8.63343 0.281291 8.04315 0.281276 7.71113 0.711309L0.206129 10.7016C-0.0969428 11.0942 -0.0618533 11.6908 0.284508 12.0343C0.630869 12.3778 1.15734 12.338 1.46041 11.9455L8.33824 2.76748L15.2153 11.9455Z" fill="#1A1A1A"/>
  </svg>
);

export default ChevronIcon;
